import "./BuildingAndSupport.module.css";
import Header from "@/reusable_sections/Header";
import Dashboard from "./sections/Dashboard";
import TheArchive from "./sections/TheArchive";
import GetInTouch from "./sections/GetInTouch";
import ComplexServiceOffer from "./sections/ComplexServiceOffer";
import BasDePageOsteomed from "@/reusable_sections/Footer";
export default function BuildingAndSupportPage() {
  return <div>
      <Header />
      <Dashboard />
      <TheArchive />
      <GetInTouch />
      <ComplexServiceOffer />
      <BasDePageOsteomed />
    </div>;
}